<div class="sz-bottom-sheet" [class.is-open]="open()" [attr.aria-hidden]="!open()">
  <div class="sz-bottom-sheet__scrim" (click)="onScrimClick()"></div>
  <div class="sz-bottom-sheet__sheet" role="dialog" aria-modal="true">
    <div class="sz-bottom-sheet__handle" aria-hidden="true"></div>
    <div class="sz-bottom-sheet__header">
      <ng-content select="[szSheetHeader]" />
    </div>
    <div class="sz-bottom-sheet__body">
      <ng-content />
    </div>
    <div class="sz-bottom-sheet__cta">
      <ng-content select="[szSheetCta]" />
    </div>
  </div>
</div>
